import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function Home() {
    return (
        <Layout page={<div>
            <h3>Subjects</h3>
            <div className='subjects'>
                <Link to='/physics'>Physics</Link>
                <Link to='/maths'>Maths</Link>
                <Link to='/basicelectricalengineering'>Basic Electrical Engineering</Link>
                <Link to='/civil'>Civil</Link>
                <Link to='/engineeringvisualization'>Engineering Visualization</Link>
                <Link to='/english'>English</Link>
                <Link to='/innovationdesignthinking'>Innovation & Design Thinking</Link>
            </div>
        </div>} />
    )
}
